import ReactGA from 'react-ga';

export const initGA = () => {
  ReactGA.initialize('UA-154125543-2');
  ReactGA.pageview(window.location.pathname + window.location.search);
};
